import { StyleSheet, Platform } from 'react-native';
import { SPACING, RADIUS, COLORS, SHADOWS, TYPOGRAPHY } from '../constants/theme';

/**
 * Shared modal styles
 * To change the theme, update the constants in theme.ts
 */
export const ModalStyles = StyleSheet.create({
    overlay: {
        flex: 1,
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        justifyContent: 'center',
        alignItems: 'center',
        padding: SPACING.lg,
    },
    shell: {
        width: '100%',
        alignSelf: 'stretch',
        backgroundColor: COLORS.white,
        overflow: 'hidden',
        minWidth: 0,
    },
    shellDesktop: {
        maxWidth: 1200,
        width: '100%',
        maxHeight: '92%',
        borderRadius: RADIUS.lg,
        ...SHADOWS.xl,
    },
    shellDesktopWide: {
        maxWidth: 1400,
    },
    shellFullScreen: {
        maxWidth: '100%',
        height: '100%',
        maxHeight: '100%',
        borderRadius: 0,
    },
    shellInner: {
        flex: 1,
        minHeight: 0,
        minWidth: 0,
        width: '100%',
    },
    wrapper: {
        flexDirection: 'column',
        width: '100%',
        maxWidth: 1200,
        maxHeight: '92%',
    },
    /** Inner row so left panel (content) and right panel (form/active) sit side by side */
    modalInnerRow: {
        flex: 1,
        flexDirection: 'row',
        minWidth: 0,
    },
    wrapperWithForm: {
        maxWidth: 1400,
    },
    content: {
        backgroundColor: COLORS.white,
        padding: SPACING.xl,
        borderRadius: RADIUS.lg,
        flex: 1,
        minWidth: 400,
        maxHeight: '100%',
        ...SHADOWS.xl,
    },
    contentInPane: {
        minWidth: 0,
        borderRadius: 0,
        maxHeight: '100%',
        ...SHADOWS.xl,
        shadowOpacity: 0,
        elevation: 0,
    },
    closeButton: {
        position: 'absolute',
        top: SPACING.md,
        right: SPACING.md,
        backgroundColor: COLORS.gray200,
        width: 36,
        height: 36,
        borderRadius: 18,
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 10,
    },
    closeButtonText: {
        fontSize: 24,
        color: COLORS.gray700,
        includeFontPadding: false,
        lineHeight: 24,
    },
    title: {
        color: COLORS.feltGreen,
        marginTop: 0,
        marginBottom: SPACING.lg,
        fontSize: TYPOGRAPHY.fontSize['4xl'],
        fontWeight: TYPOGRAPHY.fontWeight.bold,
        paddingRight: 40,
        includeFontPadding: false,
    },
    detailSection: {
        marginBottom: SPACING.lg,
        paddingBottom: SPACING.lg,
        borderBottomWidth: 2,
        borderBottomColor: COLORS.gray200,
    },
    detailSectionLast: {
        borderBottomWidth: 0,
    },
    detailSectionTitle: {
        color: COLORS.feltGreen,
        marginTop: 0,
        marginBottom: SPACING.md,
        fontSize: TYPOGRAPHY.fontSize.xl,
        fontWeight: TYPOGRAPHY.fontWeight.semibold,
        includeFontPadding: false,
    },
    tariffSection: {
        backgroundColor: COLORS.gray50,
        padding: SPACING.md,
        borderRadius: RADIUS.md,
        borderWidth: 2,
        borderColor: COLORS.secondaryGoldLight,
        overflow: 'visible',
        ...(Platform.OS === 'web' ? { zIndex: 1 } : {}),
    },
    detailRow: {
        paddingVertical: SPACING.sm,
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        color: COLORS.gray900,
    },
    detailLabel: {
        color: COLORS.feltGreen,
        marginRight: SPACING.md,
        fontWeight: TYPOGRAPHY.fontWeight.semibold,
        includeFontPadding: false,
    },
    detailValue: {
        textAlign: 'right',
        flex: 1,
        color: COLORS.gray900,
        includeFontPadding: false,
    },
    detailValuePrice: {
        fontSize: TYPOGRAPHY.fontSize.xl,
        fontWeight: TYPOGRAPHY.fontWeight.bold,
        color: COLORS.secondaryGoldHover,
    },
    detailValueWarning: {
        color: COLORS.warning,
        fontWeight: TYPOGRAPHY.fontWeight.semibold,
    },
    statusBadge: {
        paddingVertical: SPACING.xs,
        paddingHorizontal: SPACING.md,
        borderRadius: RADIUS.md,
        fontWeight: TYPOGRAPHY.fontWeight.semibold,
        fontSize: TYPOGRAPHY.fontSize.sm,
        textTransform: 'uppercase',
        letterSpacing: 0.5,
        includeFontPadding: false,
    },
    modalActions: {
        marginTop: SPACING.lg,
        paddingTop: SPACING.lg,
        borderTopWidth: 2,
        borderTopColor: COLORS.gray200,
    },
    formPanel: {
        flex: 1,
        minWidth: 400,
        alignSelf: 'stretch',
    },
    overlayMobile: {
        padding: 0,
    },
    wrapperMobile: {
        maxWidth: '100%',
        width: '100%',
        maxHeight: '100%',
        height: '100%',
    },
    contentMobile: {
        minWidth: 0,
        borderRadius: 0,
        flex: 1,
        maxHeight: '100%',
    },
    formPanelMobile: {
        minWidth: 0,
        flex: 1,
    },
    mobileShell: {
        flex: 1,
        backgroundColor: COLORS.white,
        minHeight: 0,
    },
    tariffHeaderRow: {
        flexDirection: 'row',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        gap: SPACING.sm,
        zIndex: 2,
        elevation: 2,
    },
    tariffDropdownWrap: {
        position: 'relative',
    },
    tariffDropdownButton: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: SPACING.xs,
        minHeight: 30,
        paddingVertical: 3,
        paddingHorizontal: SPACING.sm,
        backgroundColor: COLORS.white,
        borderRadius: RADIUS.md,
        borderWidth: 1,
        borderColor: COLORS.gray300,
    },
    tariffDropdownButtonText: {
        fontSize: TYPOGRAPHY.fontSize.sm,
        fontWeight: TYPOGRAPHY.fontWeight.semibold,
        color: COLORS.gray900,
        includeFontPadding: false,
    },
    tariffDropdownChevron: {
        fontSize: 10,
        color: COLORS.gray600,
        includeFontPadding: false,
    },
    tariffDropdownMenu: {
        minWidth: 160,
        backgroundColor: COLORS.white,
        borderRadius: RADIUS.md,
        borderWidth: 1,
        borderColor: COLORS.gray300,
        padding: SPACING.xs,
        ...SHADOWS.md,
    },
    tariffDropdownItem: {
        paddingHorizontal: SPACING.sm,
        paddingVertical: SPACING.sm,
        borderRadius: RADIUS.sm,
    },
    tariffDropdownItemActive: {
        backgroundColor: COLORS.gray100,
    },
    tariffDropdownItemText: {
        fontSize: TYPOGRAPHY.fontSize.sm,
        fontWeight: TYPOGRAPHY.fontWeight.semibold,
        color: COLORS.gray900,
        includeFontPadding: false,
    },
    tariffDropdownItemTextActive: {
        color: COLORS.feltGreen,
    },
    tariffDropdownItemPrice: {
        marginTop: 2,
        fontSize: TYPOGRAPHY.fontSize.xs,
        color: COLORS.gray700,
        includeFontPadding: false,
    },
});
